var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fab-transition',[_c('v-btn',{staticStyle:{"position":"absolute"},attrs:{"color":"primary","fab":"","dark":"","small":"","right":"","bottom":""},on:{"click":function($event){return _vm.$emit('action')}}},[_c('v-icon',[_vm._v("refresh")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }